import {
  getNumbersAfterEditCamera,
  getNumbersAfterSites,
} from "../../EditCamera/EditCamera";
import { hydrateFlexIgnoreZonesForEditCameraPage } from "../../EditCamera/EditCameraUtils/flexIgnoreZonesEditCameraHydration";
import { useFlexIgnoreZonesOnboardingStore } from "../../Sites/SiteAboutPage/FlexIgnoreZonesOnboarding/flexIgnoreZonesOnboardingStore";
import { Dispatcher } from "../../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import {
  computeFlexZonesBaseline,
  getEditIgnoreZonesFlexPresetMenuPresets,
} from "./flexEditIgnoreZonesUtils";
import { waitForFlexCameraContextReady } from "./waitForFlexCameraContextReady";

export async function runAfterEditIgnoreZonesBaseLoad({
  signal,
  showFlexIgnoreZones,
  hasFlexSchedule,
  setPageLoading,
  setVisibleIgnoreZones,
  setLoadProgress,
  setLoadMessage,
  setFlexZonesBaseline,
  setSelectedFlexPresetLocalId,
  isMounted,
}: {
  signal: AbortSignal;
  showFlexIgnoreZones: boolean;
  hasFlexSchedule: boolean;
  setPageLoading: Dispatcher<boolean>;
  setVisibleIgnoreZones: Dispatcher<any>;
  setLoadProgress: Dispatcher<number | undefined>;
  setLoadMessage: Dispatcher<string>;
  setFlexZonesBaseline: Dispatcher<Record<string, string>>;
  setSelectedFlexPresetLocalId: Dispatcher<string>;
  isMounted: () => boolean;
}): Promise<void> {
  const cameraId = Number(getNumbersAfterEditCamera(location.href));
  const siteId = Number(getNumbersAfterSites(location.href));

  if (!showFlexIgnoreZones || !hasFlexSchedule) {
    if (isMounted()) {
      setPageLoading(false);
    }
    return;
  }

  try {
    if (isMounted()) {
      setLoadMessage("Loading flex ignore zones…");
      setLoadProgress(82);
    }
    await hydrateFlexIgnoreZonesForEditCameraPage(siteId, {
      signal,
      focusCameraId: cameraId,
    });
    if (!isMounted() || signal.aborted) {
      return;
    }
    const enabled =
      useFlexIgnoreZonesOnboardingStore.getState().enabledBySite[siteId] === true;
    if (!enabled) {
      if (isMounted()) {
        setLoadProgress(undefined);
        setLoadMessage("");
        setPageLoading(false);
      }
      return;
    }
    if (isMounted()) {
      setLoadProgress(88);
      setLoadMessage("Loading flex schedule presets…");
    }
    // `syncFlexIgnoreZonesEnabledFromApi` (inside hydrate) already loads camera contexts when presets exist.
    await waitForFlexCameraContextReady(cameraId, signal);
    if (!isMounted() || signal.aborted) {
      return;
    }
    const presets =
      useFlexIgnoreZonesOnboardingStore.getState().presetsByCamera[cameraId] || [];
    const menuPresets = getEditIgnoreZonesFlexPresetMenuPresets(presets);
    if (isMounted()) {
      setFlexZonesBaseline(computeFlexZonesBaseline(presets));
      if (menuPresets.length > 0) {
        setSelectedFlexPresetLocalId(menuPresets[0].localId);
        setVisibleIgnoreZones(JSON.parse(JSON.stringify(menuPresets[0].zones || [])));
      }
    }
  } catch {
    /* best-effort */
  } finally {
    if (isMounted()) {
      setLoadProgress(undefined);
      setLoadMessage("");
      setPageLoading(false);
    }
  }
}
